import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {
    IAccessTable,
    IAppSettingsWrap,
    ICommon,
    ICRUDCommand,
    ICRUDRecord,
    Id,
    IPage,
    IPager,
    IPaintSource,
    IResource,
    IResourcePreview,
    IPlayerProps,
    ISceneTreeSearchResult,
    ISceneTreeSliceResults,
    IUser,
    ExperienceLevelType
} from "../../../interfaces";
import {timeout} from "../../../decorators/timeout";
import {EnumMediaType, IDialogGetAsset} from "../../../components/dialog-get-asset/dialog-get-asset.component";
import {AccessService, AppService, CommonService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {ActivatedRoute, Router} from "@angular/router";
import {getPlayerIdInScene, getPlayerIdsOfResourceId, getResourcePreview, isHostDevOrLocal, isNullOrUndefOrEmpty, LargePageSizeOptions} from '../../../common';
import {DialogClipboardComponent} from "../../../components/dialog-clipboard/dialog-clipboard.component";
import {DialogImageFullScreenComponent} from "../../../components/dialog-fullscreen-view/dialog-fullscreen-view.component";
import {BehaviorSubject, combineLatest} from "rxjs";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import {IGroupCollection} from "../../../interfaces/enterprise-interface";
import {filter, map} from "rxjs/operators";
import {actionAddPaint, actionCRUDRecord, actionRemoveCatalogResource, actionRemoveResources, actionRemoveSceneBlocks, actionUpdateSceneItem} from "../../../store/actions/user.actions";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {TranslocoService} from "@ngneat/transloco";
import {ResourceDashboardComponent} from "../resource-dashboard/resource-dashboard.component";
import {Lib} from "../../../../libs/Lib";
import * as _ from "lodash";


@Component({
    selector: 'app-resource-list',
    templateUrl: './resource-list.component.html',
    styleUrls: ['./resource-list.component.scss']
})
export class ResourceListComponent extends Compbaser implements OnInit {

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Output() itemSelected = new EventEmitter<number>();
    @Output() toggleMinimize = new EventEmitter<any>();
    @Output() fileUpload = new EventEmitter<any>();
    // @Output() selectedItems = new EventEmitter<SelectionModel<number>>();

    @Input() autoSelectTabIndex: number | null = 0;
    @Input() dialogGetAsset: IDialogGetAsset;

    @Input() set setResources(i_resources) {
        if (!i_resources) {
            this.dataSource = new MatTableDataSource([]);
            return;
        }
        this.resources = i_resources;
        this.applyTableCustomization();
    }

    readonly pageSizeOptions = LargePageSizeOptions;
    pageSize = 10;
    theme = true;
    isHostDevOrLocal = false;
    globalFilter = '';
    columnFilter = {
        tree_path: ''
    };
    hideRadios = false;
    categorySelected;
    categories = [];
    stringJSPipeArgs = {
        toDateFromTimestamp: ['MM/DD/YYYY']
    };
    resources: IResource[];
    m_enumMediaType = EnumMediaType;
    m_enumMediaTypeSelected = EnumMediaType.ALL;
    dataSource: MatTableDataSource<IResource>;
    dataSourceThumbnails$: BehaviorSubject<IResource[]>;
    scenes: IPlayerProps[];
    selectedResource: IResource;
    selectedResources: IResource[];
    resourcePreview: IResourcePreview;
    displayedColumns: string[] = ['select', 'name', 'type', 'time', 'size', 'category'];
    selection: SelectionModel<number>;
    coreAppData: IAppSettingsWrap;
    accessConfig: IAccessTable;
    groupCollection: IGroupCollection;
    isFullFeatures: boolean;
    user: IUser;
    lastGetTime;
    allowMultiSelect = true;
    loading = false;
    viewMode: 'list' | 'grid' = 'grid';
    m_enumMediaTypeItems: [number, string][] = [];
    isPaginating = false;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;


    constructor(public storeSelector: StoreSelectorsService,
                public router: Router,
                protected override dialog: MatDialog, public cdr: ChangeDetectorRef,
                private commonService: CommonService,
                private translocoService: TranslocoService,
                private containerService: ContainerService,
                private appService: AppService,
                private accessService: AccessService,
                private route: ActivatedRoute,
                private localStoreService: LocalStoreService) {
        super();
        this.pageSize = parseInt(this.localStoreService.getStorageValConfig('pageSize')) || 10;
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.cod(
            this.storeSelector.getLastGetTime()
                .subscribe((v) => {
                    this.lastGetTime = v;
                })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.storeSelector.getScenes().subscribe((i_scenes) => {
                this.scenes = i_scenes;
            })
        );
        this.cod(
            this.accessService.getGroupsTable('SignStudio Resources', "resources").subscribe((v) => {
                this.accessConfig = v;
            })
        );
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Resources").pipe(map((value) => value)).subscribe((v) => {
                this.groupCollection = v;
            })
        );
        this.cod(
            this.route.queryParams.subscribe(params => {
                if (params && params['filter']) {
                    this.globalFilter = params['filter'];
                    this.applyFilter();
                }
            })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                })
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );

        this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
            })
        );
    }

    initRadios() {
        let allEnumItems = Object.keys(EnumMediaType)
            .filter(key => isNaN(+key)) // ignore numeric keys
            .map(key => [EnumMediaType[key] as number, key] as [number, string]);
        allEnumItems = allEnumItems.filter(([val]) => true);
        this.m_enumMediaTypeItems = allEnumItems;
    }

    removeSoundOptions() {
        if (this.dialogGetAsset?.mode && this.dialogGetAsset.mode !== 'RESOURCE:SOUND' && this.dataSource && this.dataSource.data.length > 0) {
            // remove mp3 from dataSource
            this.dataSource.data = this.dataSource.data.filter(
                file => file.resource_type !== 'mp3'
            );
            // remove sound option in radio
            let allEnumItems = Object.keys(EnumMediaType)
                .filter(key => isNaN(+key)) // ignore numeric keys
                .map(key => [EnumMediaType[key] as number, key] as [number, string]);
            allEnumItems = allEnumItems.filter(([val]) => val !== EnumMediaType.SOUND);
            this.m_enumMediaTypeItems = allEnumItems;
        }
    }

    ngOnInit() {
        this.initRadios();
        if (this.dialogGetAsset?.mode) {
            this.allowMultiSelect = true;
        }
        const initialSelection = [];
        this.selection = new SelectionModel<number>(this.allowMultiSelect, initialSelection);
        this.onResourcePreview();

        this.cod(
            this.storeSelector.getResources()
                .subscribe((i_resource) => {
                    this.categories = [];

                    i_resource.forEach((s, idx) => {
                        if (s.tree_path && !this.categories.includes(s.tree_path)) {
                            this.categories.push(s.tree_path);
                        }
                    });

                    this.categories = this.categories
                        .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
                        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

                    this.containerService.setCategories(this.categories);
                })
        );
    }

    onFilterSelection(e) {
        this.selection.clear();
        this.clearFilter();
        this.m_enumMediaTypeSelected = e.value[0];
        this.applyTableCustomization();
    }

    getSelectionModel(): SelectionModel<number> {
        return this.selection;
    }

    @Memoizee({})
    isSelected(selected_id) {
        return this.selection.isSelected(Number(selected_id));
    }

    onDeselect() {
        this.selection.clear();
    }

    /**
     // Great example of how to use paginator with custom data source
     changeThumbnailView(event) {
     console.log(event.length);
     console.log(event.pageIndex);
     console.log(event.pageSize);
     console.log(event.previousPageIndex);
     // this.dataSourceThumbnails.data = this.dataSource.data.splice(0, event.pageSize);
     // possible call to a function in a service to get data from one index to another one
     this.obs$ = this.data.service.getItems(event.previousPageIndex * event.pageSize,
     event.PageIndex * event.pageSize
     )
     }
     **/

    importResource() {
        if (!this.accessConfig?.add) return this.accessService.showNoAccess();
        this.router.navigate([`/resources/new`]);
    }

    clipboardOpenDialog() {
        const dialogRef = this.dialog.open(DialogClipboardComponent, {
            height: '450px',
            width: '610px',
            data: {resources: this.selection}
        });
        // this.cod(
        //     dialogRef.afterClosed()
        //         .pipe(take(1))
        //         .subscribe((dialogGetAsset: IDialogGetAsset) => {
        //         })
        // );
    }

    showFullScreenImage() {
        if (!this.resourcePreview) {
            this.resourcePreview = getResourcePreview(this.selectedResource, this.coreAppData, false, -1, false);
        }

        const dialogRef = this.dialog.open(DialogImageFullScreenComponent, {
            height: '100vh',
            width: '100vw',
            panelClass: 'fullscreen-dialog',
            data: {url: this.resourcePreview.url}
        });
    }

    uploadFiles() {
        if (!this.accessConfig?.add) return this.accessService.showNoAccess();
        this.fileUpload.emit();
    }

    onCategoryChange(e) {
        // if (!e.value) this.columnFilter.tree_path = '';
        this.columnFilter.tree_path = e.value ? e.value : '';
        this.applyFilter();
        // this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const pageSize = this.dataSource.paginator.pageSize;
        if (numSelected === pageSize) {
            return true;
        } else {
            if (this.dataSource.filteredData.length > pageSize) {
                return false;
            } else {
                return this.dataSource.filteredData.length === numSelected;
            }
        }
    }

    /** Selects all rows if they are not all selected; otherwise clear selection */
    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            const pageIndex = this.dataSource.paginator.pageIndex;
            const pageSize = this.dataSource.paginator.pageSize;
            let endIndex: number;
            if (this.dataSource.filteredData.length > (pageIndex + 1) * pageSize) {
                endIndex = (pageIndex + 1) * pageSize;
            } else {
                endIndex = this.dataSource.filteredData.length;
            }

            for (let index = (pageIndex * pageSize); index < endIndex; index++) {
                this.selection.select(this.dataSource.filteredData[index].resource_id as any);
            }
        }
    }

    onSelectedThumb(resource) {
        // if (!this.dialogGetAsset) {
        //     this.selection.clear();
        // }
        this.selection.toggle(resource.resource_id);
        this.resourceChecked(resource.resource_id);
        this.cdr.detectChanges();
    }

    applyFilter() {
        if (this.dataSource) {
            this.dataSource.filter = JSON.stringify(this.columnFilter);
        }
    }

    @timeout()
    applyTableCustomization() {
        if (this.dialogGetAsset?.mode) {
            switch (this.dialogGetAsset.mode) {
                case "RESOURCE:SOUND": {
                    this.m_enumMediaTypeSelected = EnumMediaType.SOUND;
                    this.hideRadios = true;
                    break;
                }
                case "RESOURCE:VIDEOS": {
                    this.m_enumMediaTypeSelected = EnumMediaType.VIDEOS;
                    break;
                }
                case "RESOURCE:IMAGES": {
                    this.m_enumMediaTypeSelected = EnumMediaType.IMAGES;
                    break;
                }
                case "SCENE_RESOURCE:PLAYER": {
                    break;
                }
            }
        }
        const resourceCategories = this.resources?.filter((i_resource) => {
            switch (this.m_enumMediaTypeSelected) {
                case EnumMediaType.ALL: {
                    return true;
                }
                case EnumMediaType.SOUND: {
                    return i_resource.resource_type === 'mp3';
                }
                case EnumMediaType.VIDEOS: {
                    return i_resource.resource_type.toLocaleLowerCase() === 'mp4';
                }
                case EnumMediaType.IMAGES: {
                    return i_resource.resource_type.toLocaleLowerCase() !== 'mp4';
                }
            }
        });
        if (this.dataSource) {
            this.dataSource.data = resourceCategories;
            // this.dataSourceThumbnails.data = resourceCategories;
            this.dataSourceThumbnails$ = this.dataSource.connect();
        } else {
            this.dataSource = new MatTableDataSource(resourceCategories);
            this.dataSourceThumbnails$ = this.dataSource.connect();
            // this.dataSourceThumbnails = new MatTableDataSource(resourceCategories);
            // this.dataSourceThumbnails.data = this.dataSource.data.splice(0, 10);
        }
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        // this.dataSource.filterPredicate = (data: any, filter) => {
        //     const dataStr = JSON.stringify(data).toLowerCase();
        //     return dataStr.indexOf(filter) !== -1;
        // };
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sortingDataAccessor = (item: IResource, property) => {
            switch (property) {
                case 'name':
                    return item.resource_name;
                case 'type':
                    return item.resource_type;
                case 'time':
                    return parseInt(item.resource_date_modified);
                case 'size':
                    return parseFloat(item.resource_bytes_total);
                case 'category':
                    return item.tree_path;
                default: {
                    return item[property];
                }
            }
        };
        this.removeSoundOptions();
        this.applyFilter();
    }

    resourceChecked(resourceId) {
        this.itemSelected.emit(resourceId);
        // this.selectedItems.emit(this.selection);
    }

    private clearFilter() {
        this.categorySelected = '';
        this.columnFilter.tree_path = '';
        this.globalFilter = '';
    }

    clearSelection() {
        this.globalFilter = '';
        this.applyFilter();
    }

    customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            let globalMatch = !this.globalFilter;

            if (this.globalFilter) {
                // search all fields
                globalMatch = JSON.stringify(data).toString().toLowerCase().indexOf(this.globalFilter.trim().toLowerCase()) !== -1;
            }

            if (!globalMatch) {
                return false;
            }

            const filterObj = JSON.parse(filter);
            let isFilter = true;
            for (const col in filterObj) {
                if (typeof data[col] !== 'undefined' &&
                    data[col].toString().toLowerCase().indexOf(filterObj[col].trim().toLowerCase()) == -1) {
                    isFilter = false;
                    break;
                }
            }
            return isFilter;
        };
        return myFilterPredicate;
    }


    private crudResource(command: ICRUDCommand, id, body) {
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command,
                primary: 'resource_id',
                table: 'resources',
                body,
                id
            }
        }));
    }

    private removeResources() {
        const resourceIds = this.selection.selected.map((i_resourceId) => String(i_resourceId));
        this.storeSelector.dispatch(actionRemoveResources({resourceIds}));
        this.crudResource('delete', resourceIds, null);
    }

    private removeResourcesUsedInCatalog() {
        /** Update catalog items about removed resources */
        const removeItems = this.selection.selected.map((resourceId) => ({
            catalog_item_resource_id: null,
            catalog_item_id: null,
            resource_id: String(resourceId)
        }));
        this.storeSelector.dispatch(actionRemoveCatalogResource(
            {catalogItemResources: removeItems})
        );

        /** Update store */
        const removeIds = removeItems.map((v) => v.resource_id);
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: 'delete',
                primary: 'catalog_item_resource_id',
                table: 'catalog_item_resources',
                body: null,
                id: removeIds
            }
        }));
    }

    private removeResourcesUsedInScheduler() {
        /** remove resource schedule event */
        const resourceIds = this.selection.selected.map((resourceId) => String(resourceId));
        this.commonService.removeScheduleEventsBySources('resource', resourceIds);
    }

    private removeResourcesUsedInScenes() {
        const updatedSceneIds: Id[] = [];
        this.selection.selected.forEach((resourceId) => {
            const scenes: IPlayerProps[] = this.scenes;
            const searchResourceResult: ISceneTreeSearchResult[] = getPlayerIdsOfResourceId(scenes, String(resourceId));

            searchResourceResult.forEach((v) => {
                let sceneData;

                if (v.lastPlaylistId) {
                    sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastPlaylistId);
                    this.removeResourcesInPlaylists(sceneData, String(resourceId));
                }
                if (v.lastLocationId) {
                    sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastLocationId);
                    this.removeResourcesInLocation(sceneData, String(resourceId), 'GPS');
                    this.removeResourcesInLocation(sceneData, String(resourceId), 'Fixed');
                }
                if (!v.lastLocationId && !v.lastPlaylistId && v.lastImageId) {
                    sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastImageId);

                    // remove image/svg/video components from scene
                    this.storeSelector.dispatch(actionRemoveSceneBlocks({
                        sceneId: sceneData.sceneId,
                        sceneItemId: null,
                        values: [{
                            key: null,
                            value: sceneData.sceneItem.$.id,
                            storePath: 'Data[0].Scene[0].Players[0].Player'
                        }],
                        disableCRUD: true
                    }));
                    this.storeSelector.dispatch({type: 'BREAK_MERGE'});
                }
                if (!sceneData) {
                    this.storeSelector.dispatch(actionRemoveSceneBlocks({
                            sceneId: v.sceneId,
                            sceneItemId: null,
                            values: [{
                                key: null,
                                value: v.sceneItemId,
                                storePath: 'Data[0].Scene[0].Players[0].Player'
                            }],
                            disableCRUD: true
                        })
                    );
                }

                if (updatedSceneIds.indexOf(String(v.sceneId)) === -1) {
                    updatedSceneIds.push(String(v.sceneId));
                }
            });
        });

        this.appService.updateMultiScene(updatedSceneIds);
    }

    onDelete() {
        if (!this.accessConfig?.del) return this.accessService.showNoAccess();
        if (this.selection.selected.length === 0) return;
        const localRemText1 = this.translocoService.translate('general.areYouSure', {}, this.translocoService.getActiveLang());
        const localRemText2 = this.translocoService.translate('general.resources', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            width: '400px',
            data: {name: `${localRemText1} [ ${this.selection.selected.length} ] ${localRemText2}?`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.removeResourcesUsedInScenes();
                this.removeResourcesUsedInCatalog();
                this.removeResourcesUsedInScheduler();
                this.removeResources();
                this.resetSelection();
            }
        });
    }

    private removeResourcesInPlaylists(playerSceneData: ISceneTreeSliceResults, resourceId: Id) {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        _.remove(components.Playlist[0].Page, (v: IPage) => {
            if (v.$.type !== 'resource') return;
            return v.Player[0].Data[0].Resource[0].$.resource === resourceId;
        });

        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: playerSceneData.sceneId,
            sceneItemId: playerSceneData.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: components.Playlist[0].Page,
                storePath: `Data[0].Playlist[0]`
            }],
            disableCRUD: true
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    private removeResourcesInLocation(playerSceneData: ISceneTreeSliceResults, resourceId: Id, slice: 'GPS' | 'Fixed'): boolean {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        try {
            /* 2-18-2023 if no such path and crashes, return true to exit */
            const test = components.LocationBased[0][slice][0].Page;
        } catch (e) {
            return true;
        }
        _.remove(components.LocationBased[0][slice][0].Page, (v: IPager) => {
            if (_.isEmpty(v)) return true;
            if (v.$.type !== 'resource') return false;
            return v.Player[0].Data[0].Resource[0].$.resource === resourceId;
        });
        const storePath = `Data[0].LocationBased[0][${slice}][0]`;
        const value = components.LocationBased[0][slice][0]['Page'];
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: playerSceneData.sceneId,
            sceneItemId: playerSceneData.sceneItem.$.id,
            values: [{
                key: 'Page',
                value,
                storePath
            }],
            disableCRUD: true
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    private resetSelection() {
        this.selection.clear();
    }

    async onEditResource() {
        if (!this.selectedResource.resource_id || !this.resourcePreview) return;
        this.localStoreService.setStorageValConfig('paintEnabled', '1');
        // this.getMeta("https://oregon-signage-resources.s3-us-west-2.amazonaws.com/business595375/resources/109.svg", (err, img) => {
        //     console.log(img.naturalWidth, img.naturalHeight);
        // });
        let imageW = 500;
        let imageH = 500;
        if (this.resourcePreview.url) {
            try {
                const img = await Lib.getMeta(this.resourcePreview.url);
                imageW = img['naturalWidth'];
                imageH = img['naturalHeight'];
            } catch {
                console.log("image size error");
            }
        }
        this.cod(
            this.storeSelector.getPaints().subscribe((i_paints) => {
                if (i_paints) {
                    const i_paint = i_paints.find((p) => p.resource_id === this.selectedResource.resource_id);
                    if (i_paint) {
                        this.router.navigateByUrl(`/paint/edit/${i_paint.id}`);
                        return;
                    }
                }
                const newPainter = {
                    painter_name: this.selectedResource.resource_name ? this.selectedResource.resource_name : 'resource paint',
                    painter_data: null,
                    resource_id: this.selectedResource.resource_id,
                    width: `${imageW}`,
                    height: `${imageH}`,
                    tree_path: '',
                    created_at: Math.round(new Date().getTime() / 1000) + '',
                    updated_at: Math.round(new Date().getTime() / 1000) + ''
                };
                /** Add new painter */
                const saveRecord: ICRUDRecord = {
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'add',
                    primary: 'painter_id',
                    table: 'painters',
                    body: newPainter,
                    id: null
                };
                this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    /** important dont update store since server command failed **/
                    if (!i_crudReply.serverReply.status) return;
                    newPainter['id'] = String(i_crudReply.serverReply.id);
                    this.storeSelector.dispatch(actionAddPaint({
                        data: newPainter as IPaintSource
                    }));
                    this.router.navigateByUrl(`/paint/edit/${i_crudReply.serverReply.id}`);
                });
            })
        );
    }

    onThemeChanged(e) {
        this.theme = !this.theme;
        // if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        // this.localStoreService.setStorageValConfig('theme', e.value);
    }

    onResourcePreview() {
        const resources$ = this.storeSelector.getResources();
        const changed$ = this.selection.changed;
        this.cod(
            combineLatest([changed$, resources$]).pipe(map(([a, resourcesArray]) => {
                    return this.selection.selected.map((v) => {
                        return resourcesArray.find((s) => s.resource_id === String(v));
                    });
                })
            ).subscribe((value) => {
                if (value.length === 0) {
                    this.selectedResource = null;
                    return this.selectedResources = null;
                }
                if (value.length === 1) {
                    this.selectedResource = value[0];
                    this.selectedResources = null;
                    if (!this.selectedResource) return;
                    this.resourcePreview = getResourcePreview(this.selectedResource, this.coreAppData, false, -1, false);
                    // Lib.DevShow('Preview resource ' + this.resourcePreview.url);
                    return;
                }
                /** multiple resources **/
                this.selectedResource = null;
                this.selectedResources = value;
            })
        );
    }

    showResourceDashboard() {
        const dialogRef = this.dialog.open(ResourceDashboardComponent, {
            // height: '500px',
            // width: '1200px',
        });
    }

    onPageChange($event) {
        // Prevent rapid pagination to avoid videogular race condition
        if (this.isPaginating) {
            return;
        }

        this.isPaginating = true;

        if ($event.pageSize == this.pageSize) {
            window.stop();
            this.selection.clear();
        }
        this.pageSize = $event.pageSize;

        // Trigger re-render with animation by forcing change detection
        // This gives videos time to initialize and looks smooth
        setTimeout(() => {
            this.cdr.detectChanges();
        }, 50);

        // Re-enable pagination after 150ms delay to prevent race condition
        setTimeout(() => {
            this.isPaginating = false;
        }, 150);
    }
}

// onEditResource() {
//     if (this.selection.selected.length !== 1) return;
//
//     if (!this.selectedResource) return;
//     if (!checkImageType(this.selectedResource?.resource_type)) return;
//     this.loading = true;
//
//     this.selection.selected.forEach((i_resourceId) => {
//         this.cod(
//             this.storeSelector.getPaints().subscribe((i_paints) => {
//                 if (i_paints) {
//
//                     const i_paint = i_paints.find((p) => p.resource_id === String(i_resourceId));
//                     if (i_paint) {
//                         setTimeout(() => {
//                             this.loading = false;
//                             this.router.navigateByUrl(`/paint/edit/${i_paint.id}`);
//                         }, 500);
//                         return;
//                     }
//                 }
//                 const imgWidth = parseInt(this.selectedResource.resource_pixel_width, 0);
//                 const imgHeight = parseInt(this.selectedResource.resource_pixel_height, 0);
//
//                 const newPainter = {
//                     painter_name: this.selectedResource.resource_name,
//                     painter_data: null,
//                     resource_id: String(i_resourceId),
//                     width: imgWidth > 0 ? this.selectedResource.resource_pixel_width : '500',
//                     height: imgHeight > 0 ? this.selectedResource.resource_pixel_height : '500',
//                     tree_path: '',
//                     created_at: Math.round(new Date().getTime() / 1000) + '',
//                     updated_at: Math.round(new Date().getTime() / 1000) + ''
//                 };
//
//                 /** Add new painter */
//                 const saveRecord: ICRUDRecord = {
//                     studioId: this.localStoreService.getStorageConfig().studioId,
//                     command: 'add',
//                     primary: 'painter_id',
//                     table: 'painters',
//                     body: newPainter,
//                     id: null
//                 };
//                 this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
//                     /** important dont update store since server command failed **/
//                     //
//
//                     if (!i_crudReply.serverReply.status) {
//                         this.loading = false;
//                         return;
//                     }
//
//                     newPainter['id'] = String(i_crudReply.serverReply.id);
//
//                     this.storeSelector.dispatch(actionAddPaint({
//                         data: newPainter as IPaintSource
//                     }));
//
//                     setTimeout(() => {
//                         this.loading = false;
//                         this.router.navigateByUrl(`/paint/edit/${i_crudReply.serverReply.id}`);
//                     }, 500);
//                 });
//             })
//         );
//     });
// }
